import axios from 'axios'
import { useApi } from './api'

export const apiOrdemDeServico = () => {
  const { api } = useApi()

  const obter = async (params) => {
    const { data } = await api.get('/ordem-servico', { params })
    return data
  }
  const aceitarOuRecusar = async (payload) => {
    const { data } = await api.put(`/ordem-servico/${payload.id}/status`, payload.body)

    return data
  }

  return {
    obter,
    aceitarOuRecusar
  }
}
